<template>
  <span @click="show" class="confirm_link">{{ text }}</span>
  <div v-show="isOpen" class="box">
    <div @click="hide" class="close"></div>
    <div class="doc">
      <object v-if="type === 'pdf'" :data="file_data" type="application/pdf" width="100%" height="100%"></object>
      <iframe v-if="type === 'html'" ref="html" srcdoc=""></iframe>
    </div>
  </div>
</template>

<script>
import { url } from "@/profile/composables/url";
import axios from "axios";

export default {
  name: "DocPreviewComponent",
  props: {
    contract_id: {
      type: String,
      required: true
    },
    link: {
      type: String,
      default: undefined
    },
    text: {
      type: String
    },
    index: Number,
    type: String
  },
  data: () => {
    return {
      file_data: "",
      isOpen: false,
      html_el: "dddd",
      links: [
        {
          reg: false,
          type: "policy_html"
        },
        {
          reg: new RegExp(/Декларация.{1,9}Застрахованного.{1,9}лица/i),
          type: "policy_html"
        },
        {
          type: "rules_html"
        },
        {
          reg: new RegExp(/Информация.{1,9}об.{1,9}условиях.{1,9}договора.{1,9}добровольного.{1,9}страхования/ig),
          type: "policy_html"
        },
        {
          reg: new RegExp(/ПАМЯТКА.{1,9}К.{1,9}ПОЛИСУ.{1,9}СТРАХОВАНИЯ.{1,9}ЖИЗНИ/i),
          type: "policy_html"
        },
        {
          reg: new RegExp(/Согласие.{1,9}на.{1,9}обработку.{1,9}персональных.{1,9}данных/i),
          type: "policy_html"
        }
      ]
    };
  },
  methods: {
    showPolicy(html, reg) {
      let alias_link = false,
        h = html;
      if (reg !== false) {
        let i = 0;
        h = html.replace(
          reg,
          function(a) {
            i++;
            let s = "";
            if (i > 1) s = i;
            alias_link = "".concat("link", s);
            return "".concat("<a id=\"", "link", s, "\"></a>", a);
          }
        );
      }
      this.html_el.setAttribute("srcdoc", h);
      if (alias_link !== false)
        setTimeout(function() {
          const iframes = document.getElementsByTagName("iframe");
          for (let i = 0; i < iframes.length; i++) {
            const iframe = iframes[i];
            const iframeDoc = iframe.contentWindow.document;
            const element = iframeDoc.getElementById(alias_link);
            if (element) {
              element.scrollIntoView();
              break;
            }
          }
        }, 100);
    },
    show() {
      let item = this.links[this.index];
      if (!item) return;
      if (item.type === "rules_html") {
        this.file_data = this.link;
        this.isOpen = true;
        return;
      }
      // console.log(this.link);
      if (this.link !== undefined) {
        this.isOpen = true;
        this.showPolicy(this.link, item.reg);
        return;
      }
      this.isOpen = true;
      this.html_el.setAttribute("srcdoc", "<div style=\"text-align: center;margin 40%;padding:1em;background:#ffffff\">Загружаю документ</div>");

      this.getProlongation(item.reg);
    },
    hide() {
      this.isOpen = false;
    },
    getProlongation(reg) {
      let params = {
        command: "prolongation_html",
        contract_id: this.contract_id,
        token: this.$myApp.token.get()
      };
      let $this = this;
      axios
        .post(url, {
          params: params
        })
        .then(function(response) {
          let data = response.data;
          // console.log(data);
          if (data.state == "ERR") {
            $this.errors = [];
            $this.errors.push(data.msg_text);
          }
          if (data.state == "OK") {
            $this.$emit("loadhtml", data.html);
            $this.showPolicy(data.html, reg);
          }
        });
    }
  },
  mounted() {
    this.html_el = this.$refs.html;
  }
};
</script>

<style scoped>
.confirm_link {
  color: #0a246a;
  font-weight: bold;
}

.confirm_link:hover {
  text-decoration: underline;
  color: #850000;
  cursor: pointer;
}

.box {
  position: fixed;
  z-index: 1000;
}

.box .close {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}

.box .close:after {
  position: fixed;
  top: 10vh;
  right: 10vw;
  right: 0;
  right: calc(50vw - 512px);
  content: 'X';
  font-size: 3vw;
  color: #ffffff;
  font-weight: 600;
  display: block;
  width: 1.2em;
  height: 1.2em;
  margin: -1em;
  text-align: center;
}

.box .doc {
  position: fixed;
  left: 10vw;
  left: calc(50vw - 512px);
  top: 10vh;
  right: 10vw;
  right: calc(50vw - 512px);
  bottom: 10vh;
  overflow: auto;
  background: rgba(200, 200, 200, 0.5);
  text-align: center;
}

@media (max-width: 1024px) {
  .box .close:after {
    right: 20px;
  }

  .box .doc {
    left: 20px;
    right: 20px;
  }
}

.box .doc iframe,
.box .doc object {
  width: 100%;
  height: 98%;
}

.box .doc object {
  overflow: auto;
}
</style>